import L from 'leaflet';
import '@supermap/iclient-leaflet';
const resolutions = [
	0.703125,
	0.3515625,
	0.17578125,
	0.087890625,
	0.0439453125,
	0.02197265625,
	0.010986328125,
	0.0054931640625,
	0.00274658203125,
	0.001373291015625,
	6.866455078125E-4,
	3.4332275390625E-4,
	1.71661376953125E-4,
	8.58306884765625E-5,
	4.291534423828125E-5,
	2.1457672119140625E-5,
	1.0728836059570312E-5,
	5.364418029785156E-6,
	2.682209014892578E-6,
	1.341104507446289E-6,
	6.705522537231445E-7
];

function init() {
	const map = L.map('map', {
		center: [29.037426, 111.705255],
		maxZoom: 20,
		minZoom: 8,
		zoom: 11,
		zoomControl: false,
		logoControl: false,
		attributionControl: false,
		crs: new L.Proj.CRS("EPSG:4326", {
			origin: [-180.0, 90.0],
			resolutions: resolutions,
			bounds: L.bounds([
				110.48594409500004, 28.40830417600006
			], [
				112.29946857200002, 30.129527886000062
			])
		})
	});
	let url = "https://ysdt.cdssjj.changde.gov.cn/map/DciGateway/WMTS/2021年常德市矢量地图/00903737b10f4c7bb0b9772783726e3a";
	L.supermap.wmtsLayer(url, {
		layer: "CD_MAP", //layer根据能力文件解析
		style: "default",
		tilematrixSet: "ChinaPublicServicesCGCS2000_CD_MAP", //tilematrixSet根据能力稳定解析
		maxZoom: 20,
		format: "image/png",
		requestEncoding: 'REST'
	}).addTo(map);
	L.control.zoom().addTo(map);

	return {
		map,
		L
	}

}
export {
	init
}